import styled from 'styled-components';
import Text from 'desktop/components/Text';
import Icon from 'desktop/components/Icon';
import { colorVariables } from 'desktop/theme/variables';

export const CollapsibleStyled = styled.div`
  padding: 0 10px 10px 0;
`;

export const OuterContainer = styled.div`
  overflow: hidden;
  padding-top: 12px;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 3px;
`;

export const TriggerButton = styled.button`
  position: relative;
  height: 15px;
  width: 100%;
  text-decoration: none;
  padding: 0;
  background: transparent;
  color: white;
  border: none;
`;

export const TriggerButtonWrap = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  width: 100%;
  height: 100%;
`;

export const StyledIcon = styled(Icon)`
  && {
    margin-right: 3px;
    transform: ${(props) => (props.active ? 'rotate(270deg)' : 'rotate(180deg)')};
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      transition: 0ms ease-out;
    }

    ${TriggerButton}:hover & {
      fill: ${colorVariables.fire};
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        transition: 0ms ease-out;
      }
    }
  }
`;

export const StyledText = styled(Text)`
  && {
    font-size: 12px;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      transition: 0ms ease-out;
    }
    ${TriggerButton}:hover & {
      color: ${colorVariables.fire};
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        transition: 0ms ease-out;
      }
    }
  }
`;
